import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useEffect } from 'react';

import { Modal } from '@/components/Modal';
import { useModifyAccount } from '@/hooks';
import { useGlobalState } from '@/state/global.state';
import { AccountMetadata } from '@/types';

export const LinkAzure = () => {
  const { azureMarketplaceConfig } = useGlobalState();

  const { mutate: link, status } = useModifyAccount('link');

  function onClose() {
    azureMarketplaceConfig.onChange(undefined);
    azureMarketplaceConfig.onVerifyLinkingChange(false);
  }

  function linkAzure() {
    link({
      username: 'azuremarketplace',
      value: '',
      config: azureMarketplaceConfig.value as AccountMetadata,
    });
    onClose();
  }

  useEffect(() => {
    if (azureMarketplaceConfig.value && !azureMarketplaceConfig.verifyLinking) {
      linkAzure();
    }
  }, []);

  return (
    <Modal
      icon={<ExclamationTriangleIcon className="size-7 text-yellow-600" />}
      title={'Link to Azure'}
      onClose={onClose}
      className="px-8"
      open={azureMarketplaceConfig.verifyLinking}
      footer={{
        text: 'Confirm',
        disabled: status === 'pending',
        onClick: async () => {
          linkAzure();
        },
      }}
    >
      Are you sure you want to connect to Azure Marketplace ?
    </Modal>
  );
};
